import React, { useMemo, useEffect, useState } from "react";
import { Autocomplete, Image } from "../components/index";
import { useNewsQuery, useNewsYearsQuery } from "./queries";
export const App = () => {
    const [locale, setLocale] = useState("en");
    const [selectedYear, setSelectedYear] = useState("");
    const { refetch, status, data, hasNextPage, isFetchingNextPage, fetchNextPage, } = useNewsQuery(selectedYear);
    const { data: yearsData } = useNewsYearsQuery();
    const yearOptions = useMemo(() => {
        let options = [
            {
                id: 0,
                title: "All",
                node: "All",
                value: "",
            },
        ];
        if (yearsData) {
            yearsData.years.map((year) => {
                options.push({
                    id: Number(year),
                    node: year,
                    title: year,
                    value: year,
                });
            });
        }
        return options;
    }, [yearsData]);
    useEffect(() => {
        const lang = document.documentElement.getAttribute('lang');
        setLocale(lang);
    }, [setLocale]);
    useEffect(() => {
        refetch();
    }, [selectedYear]);
    return (React.createElement(React.Fragment, null, status === "loading" ? (React.createElement(React.Fragment, null)) : status === "error" ? (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col-12" },
            React.createElement("div", { className: "alert alert-warning" },
                React.createElement("i", { className: "icon-exclamation-solid" }),
                "Something wrong happened. Please try again later.")))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "filter" },
            React.createElement("label", { htmlFor: "" }, "Filter by years:"),
            React.createElement(Autocomplete, { options: yearOptions, defaultOption: yearOptions[0], onSelectedItemChange: (option) => {
                    setSelectedYear(option.selectedItem.value);
                } })),
        React.createElement("div", { className: "row" }, data.pages.map((page, index) => (React.createElement(React.Fragment, { key: index }, page.data.map((item) => (React.createElement("div", { key: item.id, className: "col-6 col-md-6 col-lg-4" },
            React.createElement("div", { className: "card" },
                React.createElement("div", { className: "card-thumbnail" },
                    React.createElement("a", { href: `/${locale}/resources/news/${item.slug}`, target: "_blank" },
                        React.createElement(Image, { src: item.featured_image_thumbnail, alt: item.featured_image_alt }))),
                React.createElement("div", { className: "card-body" },
                    React.createElement("p", null, item.subtitle),
                    React.createElement("h3", null,
                        React.createElement("a", { href: `/${locale}/resources/news/${item.slug}`, target: "_blank" }, item.title))))))))))),
        hasNextPage ? (React.createElement("button", { onClick: () => fetchNextPage(), disabled: isFetchingNextPage, className: "btn-loadmore" }, "More")) : null))));
};
